// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    
export class CostByPartNumber {
  section: string;
  referenceNumber: string;
  description: string;
  quantity: number;
  unitCost: number;
  cost: number;
  pmAdjustedHours: number;
  engAdjustedHours: number;
  specAdjustedHours: number;
  mechAdjustedHours: number;
  elecAdjustedHours: number;
  nengEngineerAdjustedHrs: number;
  qengEngineerAdjustedHrs: number;
  cengEngineerAdjustedHrs: number;
  eengEngineerAdjustedHrs: number;
  lengEngineerAdjustedHrs: number;
  programmingAdjustedHrs: number;
  graphicsAdjustedHrs: number;
  ddsAdjustedHrs: number;
  notes: string;
  modelNumber: string;
  manufacturerPartNumber: string;
}
